import { createSlice } from '@reduxjs/toolkit'

export const CondicionesDePagoSlices = createSlice({
    name: 'condicionesDePago',
    initialState: [],
    reducers: {
        addCondiciones: (state, action) => {
            const condiciones = Array.isArray(action.payload) ? action.payload : [];
            return [...condiciones].sort((a,b) => {
                if (a.PymntGroup < b.PymntGroup) {
                    return -1;
                  }
                  if (a.PymntGroup > b.PymntGroup) {
                    return 1;
                  }
                  return 0;
            })
        }
    }
})

export const { addCondiciones } = CondicionesDePagoSlices.actions
export default CondicionesDePagoSlices.reducer
